import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotateRight } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios'

import { formatDate } from '../../../../component/common/Helper';

const BillingInfoDetails = (props) => {
    const loginUserType = localStorage.getItem('type');
    const api_base_url = process.env.REACT_APP_API_URL;
    const {businessInfo} = props;

    // ----- define all state ----- //
    const [availableAmount, setAvailableAmount] = useState('00.00')

    useEffect(() => {
        if (businessInfo?.available_amount !== '') {
            setAvailableAmount(businessInfo.available_amount);
        }
    },[businessInfo])

    const priceCalculate = async () => {
        let apiToken = '';
        if(loginUserType === 'A'){
            apiToken = localStorage.getItem('token')
        }
        else if(loginUserType === 'D'){
            apiToken = localStorage.getItem('developertoken')
        }
        else if(loginUserType === 'SA') {
            apiToken = localStorage.getItem('systemAdminToken')
        }
        var api_headers = {
            headers: { 
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : apiToken
            }
        };
        await axios.post(`${api_base_url}admin/price-calculate`, {sass_id: localStorage.getItem('sass_id')}, api_headers)
        .then(async (res) => {
            if(res.data.status === 'success') {
                setAvailableAmount(res.data.data.availableAmount)
            } else if(res.data.status === 'error') {
                console.error('error')
            }
        })
        .catch((error) => {
            console.error(error);
        })
    }

    return (
        <>
            <div className="row g-5 g-xl-10 mb-6">
                <div className="col-xxl-12">
                    <div className="card border h-md-100">
                        <div className="card-body p-10">
                            <div className="row h-100 align-items-center">
                                <div className="col-md-8" style={{borderRight:'1px solid #dfdfdf'}}>
                                    <span className="text-gray-700 fw-bolder fs-2qx lh-1 ls-n1 mb-1">
                                        {businessInfo.business_name}
                                    </span>
                                    <span className="fw-semibold fs-6 mb-8 d-block opacity-75">
                                        {businessInfo.sass_id}
                                    </span>
                                    <div className="d-flex align-items-center flex-wrap d-grid gap-2 mb-5 mb-xl-10">
                                        <div className="d-flex align-items-center me-5 me-xl-13">
                                            <div className="">
                                                <span className="fw-semibold d-block fs-6 opacity-75">
                                                    Currency 
                                                </span>
                                                <span className="fw-bold fs-7">
                                                    {
                                                        businessInfo?.currency || ''
                                                    }
                                                </span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="">
                                                <span className="fw-semibold opacity-75 d-block fs-6">
                                                    Billing country
                                                </span>
                                                <span className="fw-bold fs-7">
                                                    {
                                                        businessInfo?.billing_country || ''
                                                    }
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex flex-column py-2">
                                        <div className="d-flex align-items-center fs-5 fw-bold mb-3">
                                            Billing Details
                                        </div>
                                        <div className="d-flex align-items-center flex-wrap d-grid gap-2">
                                            <div className="d-flex align-items-center me-5 me-xl-13">
                                                <div className="">
                                                    <span className="fw-semibold d-block fs-6 opacity-75">
                                                        Email
                                                    </span>
                                                    <span className="fw-bold fs-7">
                                                        {
                                                            businessInfo?.billing_email || 'N/A'
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center">
                                                <div className="">
                                                    <span className="fw-semibold opacity-75 d-block fs-6">
                                                        Address
                                                    </span>
                                                    <span className="fw-bold fs-7">
                                                        {
                                                            businessInfo?.billing_address || 'N/A'
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-4 ps-10'>
                                    <div className='text-end cursor-pointer d-none' style={{marginTop:'-30px'}}>
                                        <FontAwesomeIcon
                                            icon={faRotateRight} 
                                            className='fs-3 text-gray-700'
                                            onClick={priceCalculate}
                                        />
                                    </div>
                                    <div className="m-0">
                                        <p className="fw-bold text-gray-800 mb-3 fs-4">
                                            Credit remaining
                                        </p>
                                        <p className="text-gray-700 fw-bolder d-block fs-2qx lh-1 ls-n1 mb-2">
                                            {
                                                businessInfo?.available_amount && (
                                                    <>
                                                        <span>
                                                            {businessInfo?.currency || ''}
                                                        </span>
                                                        <span className='ms-2'>
                                                            {availableAmount || '00.00'}
                                                        </span>
                                                    </>
                                                )
                                            }
                                        </p>
                                        {/* <p className="text-gray-500 fw-semibold fs-6 mb-2">
                                            Valid till 26 June 2025
                                        </p> */}
                                        <p className="text-gray-500 fw-bold fs-6">
                                            {
                                                businessInfo.last_credit_amount &&
                                                businessInfo.last_credit_on ? 
                                                `Last payment ${businessInfo?.currency || ''} ${businessInfo.last_credit_amount} on ${formatDate(businessInfo.last_credit_on)}`:
                                                ``
                                            }
                                        </p>
                                    </div> 
                                    <button
                                        className="btn btn-primary mt-10"
                                        // onClick={()=> props.setAddCreditModalIsOpen(true)}
                                        disabled
                                    >
                                        Add Credit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default BillingInfoDetails